import { motion } from "framer-motion";
import { ShieldCheck, Heart, Award } from "lucide-react";
import { ABOUT_IMAGE } from "@/data/site";

const fade = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.3 },
  transition: { duration: 0.6 },
};

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <motion.div {...fade} className="relative">
          <div className="overflow-hidden rounded-3xl border border-slate-200 shadow-xl">
            <img
              src={ABOUT_IMAGE}
              alt="Professional cleaner serving the Iqaluit community"
              className="h-full w-full object-cover aspect-[4/5] lg:aspect-[5/5]"
            />
          </div>
          <div className="absolute -bottom-6 -right-2 sm:right-6 rounded-2xl bg-[#0f2452] text-white px-6 py-5 shadow-lg max-w-[230px]">
            <p className="font-display text-3xl font-extrabold">100%</p>
            <p className="text-sm text-sky-200 mt-1">
              Commitment to quality &amp; satisfaction
            </p>
          </div>
        </motion.div>

        <motion.div {...fade}>
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-[#2563eb]">
            About Us
          </span>
          <h2 className="font-display mt-4 text-3xl sm:text-4xl font-extrabold tracking-tight text-[#0f2452]">
            Our mission is a healthier, more welcoming North
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-slate-600">
            At Iqaluit Cleaning and Maintenance, our mission is to deliver
            reliable, professional, and detail-oriented cleaning services that
            create healthier, safer, and more welcoming spaces for our clients.
          </p>
          <p className="mt-4 text-lg leading-relaxed text-slate-600">
            We are committed to exceeding expectations through quality
            workmanship, integrity, and exceptional customer service — while
            building lasting relationships with homeowners, businesses, and
            property managers in our community.
          </p>

          <div className="mt-8 grid sm:grid-cols-3 gap-4">
            {[
              { icon: ShieldCheck, label: "Reliable & professional" },
              { icon: Award, label: "Quality workmanship" },
              { icon: Heart, label: "Built on integrity" },
            ].map((item, i) => (
              <div
                key={i}
                className="rounded-2xl border border-slate-200 bg-slate-50 p-5"
              >
                <item.icon className="h-7 w-7 text-[#2563eb]" />
                <p className="mt-3 text-sm font-semibold text-[#0f2452]">
                  {item.label}
                </p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
